/**
* Resets the input fields of specified forms on the page.
*
* This function targets forms with the IDs 'register-interest-form' and 'notify-me-form'.
* If any of these forms are present on the page, it will clear the values of all input fields within them.
*
* @function
* @returns {void} This function does not return a value.
*/
function formReset() {
    // Select the form element
    var $registerInterestForm = $("#register-interest-form, #notify-me-form");

    // Check if the form exists on the page
    if ($registerInterestForm.length) {
        // Find all input elements within the form and set their values to an empty string
        $registerInterestForm.find("input:visible, textarea:visible").val("");
    }
}

module.exports = formReset;
